var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeleteV2 = function SvgDeleteV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.73 7.909a.82.82 0 0 0-.818.818v9.156a1.57 1.57 0 0 1-1.645 1.477H8.735a1.57 1.57 0 0 1-1.644-1.477V8.727a.818.818 0 1 0-1.636 0v9.156a3.205 3.205 0 0 0 3.28 3.116h6.529a3.205 3.205 0 0 0 3.28-3.116V8.727a.82.82 0 0 0-.814-.818",
    "data-name": "Path 3567"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.544 5.454h-3.272V3.818A.82.82 0 0 0 14.454 3H9.546a.82.82 0 0 0-.819.818v1.637H5.455a.818.818 0 0 0 0 1.637h13.09a.818.818 0 1 0 0-1.637zm-8.183 0v-.817h3.272v.818z",
    "data-name": "Path 3568"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.182 16.089v-5.726a.818.818 0 1 0-1.636 0v5.726a.818.818 0 1 0 1.636 0",
    "data-name": "Path 3569"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.455 16.089v-5.726a.818.818 0 1 0-1.637 0v5.726a.818.818 0 0 0 1.637 0",
    "data-name": "Path 3570"
  })));
};
export default SvgDeleteV2;